/* eslint-disable no-unused-vars */

const Web = {
  closeWebView: () => {
    console.log('Load inside webview');
  },
  shouldHeaderVisible: () => {
    console.log('shouldheaderVisible');
    return false;
  },
  openDialer: (mobileNo) => {
    console.log('web open dialer function', mobileNo);
  },
  getBeatClosureData: () => {
    console.log('web call getBeatClosureData function');
  },
  callToP4B: (mid = '', merchantName = '') => {
    console.log('web call callToP4B function', mid, merchantName);
  },
  sendEventsToHawkeye: (statusCode, responseTime, responseSize, json) => {
    console.log('sendEventsToHawkeye');
  },
  openCamera: (height, width) => {
    console.log('web camera option', height, width);
  },
  openFrontCamera: (height, width) => {
    console.log('web front camera option', height, width);
  },
  deleteImage: () => {
    console.log('delete image function');
  },
  isNetworkAvailable: () => {
    console.log('isNetworkAvailable');
    return false;
  },
  getCurrentLocation: () => {
    console.log('inside get current location - WEB');
  },
  getCurrentLocationWithAccuracy: () => {
    console.log('inside get current location with accuracy - WEB');
  },
  logout: () => {
    console.log('logoutNative');
  },
  openDeepLink: (url) => {
    console.log('open Deep link', url);
  },
  openExternalApp(action, uri, category, errormessage) {
    console.log(action, uri, category, errormessage);
  },
  openCalendarExternalApp(action, uri, category, data, errormessage) {
    console.log(action, uri, category, data, errormessage);
  },
  hasPermission(string) {
    console.log(string);
  },
  analyticsEvent(event) {
    console.log(event);
  },
  manageUser() {
    console.log('inside manageUser');
  },
  getUserRole() {
    console.log('inside getUserRole for p4b');
  },
  updateEvent() {
    console.log('Inside updateEvent');
  },
  deleteEvent() {
    console.log('Inside delete event');
  },
  pushHawkeyeEvent(hawkeyeEventJson) {
    console.log('pushHawkeyeEvent', hawkeyeEventJson);
  },
  saveEventToCalendar() {
    console.log('Inside saveEventToCalendar');
  },
  getAppVersion() {
    console.log('Get app version');
    return '5.9.9';
  },
  updateWidget() {
    console.log('Inside Update Widget');
  },
  openShareDialog() {
    console.log('Inside open Share Dialog');
  },
  showQuestionsScreen(params) {
    console.log('Feedback form', params);
  },
  launchUniversalAddressComponent(data) {
    console.log('Universal Address Component', data);
  },
  launchATSInventoryPage(params) {
    console.log('ATS Inventory Page', params);
  },
};

export default Web;
